// PDF をアップロードして fileKey を親に返す。再選択や削除も可能。
// POST /api/admin/uploads/pdf を使用 (application/pdf / 20MB 以下)。
// ContentType='pdf' の編集画面で利用される。
import { useRef, useState } from "react";
import { uploadPdf, uploadsUrl } from "../lib/uploader";

interface Props {
  value: string | null; // 現在の fileKey (null = 未設定)
  onChange: (fileKey: string | null) => void;
  label?: string;
}

export function PdfUploader({ value, onChange, label = "PDF ファイル" }: Props) {
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState<string | null>(null);
  const inputRef = useRef<HTMLInputElement>(null);

  const pdfUrl = uploadsUrl(value);

  const onFile = async (file: File) => {
    setBusy(true);
    setErr(null);
    try {
      const r = await uploadPdf(file);
      onChange(r.fileKey);
    } catch (e) {
      setErr((e as Error).message ?? "アップロードに失敗しました");
    } finally {
      setBusy(false);
      if (inputRef.current) inputRef.current.value = "";
    }
  };

  return (
    <div>
      <label className="label">{label}</label>
      {pdfUrl && (
        <div className="mb-2 flex items-center gap-2 text-sm">
          <span className="font-mono text-xs text-tora-ink/60 truncate max-w-[260px]">
            {value}
          </span>
          <a
            href={pdfUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="text-xs text-tora underline"
          >
            現在の PDF を確認 📑
          </a>
        </div>
      )}
      <div className="flex items-center gap-2">
        <input
          ref={inputRef}
          type="file"
          accept="application/pdf"
          className="text-sm"
          disabled={busy}
          onChange={(e) => {
            const f = e.target.files?.[0];
            if (f) void onFile(f);
          }}
        />
        {value && (
          <button
            type="button"
            className="text-xs text-red-600 underline"
            onClick={() => onChange(null)}
            disabled={busy}
          >
            削除
          </button>
        )}
      </div>
      {busy && (
        <p className="text-xs text-tora-ink/60 mt-1">アップロード中…</p>
      )}
      {err && <p className="text-xs text-red-600 mt-1">{err}</p>}
      <p className="text-xs text-tora-ink/50 mt-1">
        PDF (application/pdf)、20MB まで
      </p>
    </div>
  );
}
